import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {Router} from '@angular/router';
import {catchError, throwError} from 'rxjs';
import { environment } from '../../../environments/environment';
import {StorageService} from '../services/storage/storage.service';
import {CurrentUserStore} from '../services/user/store/current-user.store';

export const interceptorFn: HttpInterceptorFn = (req, next) => {

  const router = inject(Router);
  const storageService = inject(StorageService);
  const currentUserStore = inject(CurrentUserStore);

  const token = storageService.getAccessToken();

  const isApiUrl =
    req.url.startsWith(environment.serverUrl) ||
    req.url.startsWith(environment.authUrl) ||
    req.url.startsWith(environment.businessUrl);

  const isLoginRequest = req.url.startsWith(environment.authUrl + '/login');

  if (isApiUrl && token) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });
  }

  return next(req).pipe(
    catchError((error: unknown) => {
      if (
        isApiUrl &&
        !isLoginRequest &&
        error instanceof HttpErrorResponse &&
        error.status === 401
      ) {
        storageService.clearStorage();
        currentUserStore.clear();
        router.navigate(['/auth/login']).then();
      }

      return throwError(() => error);
    })
  );
};
